import React from "react";

//components
import HomeBackendSections from "./HomeBackendSections";
import HomeFavoriteSection from "./HomeFavoriteSection";
import HomePopularGamesSection from "./HomePopularGamesSection";
import HomeRecentPlaySection from "./HomeRecentPlaySection";
import HomeTopShowcase from "./HomeTopShowcase";
import LiveDepositWithdrawTable from "./LiveDepositWithdrawTable";

const MainHome = ({ update }) => {
  return (
    <div className="@container">
      <HomeTopShowcase />

      <HomeRecentPlaySection />

      <HomeFavoriteSection />

      <HomePopularGamesSection />

      <HomeBackendSections />

      {/* table view */}
      <LiveDepositWithdrawTable />
    </div>
  );
};

export default MainHome;
